module.exports = __webpack_public_path__ + "img/Custodies.b44f48bc.svg";